import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Menu } from 'lucide-react';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { SidebarNavContent } from './SidebarNav';
import { StatusStrip } from './StatusStrip';
import { AppFooter } from './AppFooter';
import { Button } from '../ui/button';
import { Sheet, SheetContent } from '../ui/sheet';
import { useAuth } from '../../hooks/useAuth';
import { useRealtimeUpdates } from '../../hooks/useRealtimeUpdates';
import { useTickerSocket } from '../../hooks/useTickerSocket';

export function AppShell() {
  const { user, isLoading, isAdmin, logout } = useAuth();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useRealtimeUpdates();
  useTickerSocket();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-muted-foreground">Loading...</div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen flex-col bg-background">
      <Header
        email={user?.email || null}
        onLogout={logout}
        menuButton={
          <Button
            variant="ghost"
            size="icon"
            className="h-9 w-9 md:hidden"
            onClick={() => setMobileMenuOpen(true)}
            aria-label="Open menu"
          >
            <Menu className="h-5 w-5" />
          </Button>
        }
      />
      <Sheet open={mobileMenuOpen} onOpenChange={setMobileMenuOpen}>
        <SheetContent side="left" className="w-56 p-0 pt-14">
          <SidebarNavContent
            isAdmin={isAdmin}
            className="p-4"
            onLinkClick={() => setMobileMenuOpen(false)}
          />
        </SheetContent>
      </Sheet>
      <Sidebar isAdmin={isAdmin} />
      <main className="flex min-h-[calc(100vh-3.5rem)] flex-1 flex-col md:ml-56">
        <StatusStrip />
        <div className="flex flex-1 flex-col p-4 sm:p-6">
          <div className="flex-1">
            <Outlet />
          </div>
          <AppFooter />
        </div>
      </main>
    </div>
  );
}
